var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .path{fill:#039ae8}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 49,
    transform: "translate(-486.000000, -863.000000)",
    className: "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(485.000000, 295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,575 C14,571.140261 10.8597391,568 7,568 C3.14026087,568 2.27373675e-13,571.140261 2.27373675e-13,575 C2.27373675e-13,578.859739 3.14026087,582 7,582 L7.875,582 L7.875,580.25 L7,580.25 C4.10473913,580.25 1.75,577.895565 1.75,575 C1.75,572.104739 4.10473913,569.75 7,569.75 C9.89556522,569.75 12.25,572.104739 12.25,575 L12.25,575.875 L8.75,575.875 L13.125,580.25 L17.5,575.875 L14,575.875 L14,575 Z",
    id: "Fill-1",
    transform: "translate(8.750000, 575.000000) scale(-1, 1) translate(-8.750000, -575.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.37abdaf934377c30fa2ad57720d79b3d.svg";
export { ForwardRef as ReactComponent };